<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <!-- Licence (complex template) -->
      <div *ngIf="config.template && config.licence === Feature.required">
        <div>
          <label>Licence Key</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="licence"
              placeholder="Licence Key"
              [(ngModel)]="model.key"
              class="form-control"
              [class.is-invalid]="!isValidLicence()"
              autocomplete="off"
              required
            />
          </div>
        </div>
        <div *ngIf="config.pattern">
          <label>Licence Volume</label>
          <div class="form-group mb-3">
            <input
              type="text"
              [(ngModel)]="model.volume"
              name="volume"
              class="form-control"
              [class.is-invalid]="!isValidVolume()"
              placeholder="Licence Volume"
            />
          </div>
        </div>
        <div>
          <label>Licence Usage</label>
          <div class="form-group mb-3">
            <select
              class="form-control"
              name="usage"
              [(ngModel)]="model.usage"
              [class.is-invalid]="model.usage == null"
              [required]="config.pattern"
            >
              <option value="registration">registration</option>
              <option value="empowerment">empowerment</option>
              <option value="unrestricted">unrestricted</option>
            </select>
            <div class="info">{{ licenceUsageInfo[model.usage] }}</div>
          </div>
        </div>
      </div>

      <!-- Username / Pattern -->
      <div>
        <ng-container *ngIf="!config.pattern">
          <label>Username</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="username"
              [(ngModel)]="username"
              class="form-control"
              [class.is-invalid]="!isValidUsername()"
              autocomplete="off"
              [disabled]="!developer && config.update && !config.template"
              required
            />
            <div *ngIf="config.update && !config.template && username !== model.profile.username" class="warning">
              Updating the username is an experimental feature!
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="config.pattern">
          <label>Username Pattern</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="username"
              [(ngModel)]="username"
              class="form-control"
              [class.is-invalid]="!isValidUsername()"
              autocomplete="off"
              required
            />
            <div *ngIf="isRegularUsername()" class="warning">
              This username contains no placeholders. A regular whitelist entry should be created instead!
            </div>
            <div *ngIf="!isTemplateMail() && model.usage !== 'empowerment'" class="warning">
              This username pattern is not an e-mail address. Users can be registered <b>without validation</b>! Reset via e-mail is
              disabled.
            </div>
            <div class="info">
              All users with a matching username can register using this template.<br />
              The <code>_</code> sign matches any single character, the <code>%</code> sign matches anything.<br />
              Example: To create a template for users with straightlabs e-mail addresses use
              <code>%@str8labs.com</code>.
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Enbaled/Disabled State -->
      <div *ngIf="config.state">
        <label>State</label>
        <div class="form-group mb-3">
          <button
            type="button"
            class="btn"
            [ngClass]="model.profile.enabled ? 'btn-success' : 'btn-danger'"
            (click)="model.profile.enabled = !model.profile.enabled"
          >
            {{ model.profile.enabled ? 'Enabled' : 'Disabled' }}
          </button>
        </div>
      </div>

      <!-- Mail Address -->
      <div *ngIf="!config.pattern && model.usage !== 'empowerment'">
        <label>Mail</label>
        <div class="form-group mb-3">
          <input
            type="text"
            name="mail"
            [(ngModel)]="model.profile.meta.mail"
            class="form-control"
            [class.is-invalid]="!isValidMail()"
            autocomplete="off"
          />
          <div *ngIf="(model.profile.meta.mail == null || model.profile.meta.mail === '')" class="warning">
            <div *ngIf="config.template">
              Without e-mail the user can be registered <b>without validation</b>! Reset via e-mail is disabled.
            </div>
            <div *ngIf="!config.template">Without e-mail the password reset via e-mail is disabled!</div>
          </div>
        </div>
      </div>

      <!-- Settings & Labels -->
      <div class="float-right" *ngIf="config.settings || model.usage !== 'empowerment'">
        <label for="checkbox-expert">
          <ng-container *ngIf="config.settings">Show Settings & Labels</ng-container>
          <ng-container *ngIf="!config.settings">Show Labels</ng-container>
        </label>
        <input
          type="checkbox"
          class="checkbox-inline align-middle"
          id="checkbox-expert"
          [(ngModel)]="editCustomFields"
          [ngModelOptions]="{standalone: true}"
        />
      </div>

      <!-- Settings -->
      <div *ngIf="config.settings && model.usage !== 'empowerment'">
        <ng-container *ngIf="editCustomFields">
          <label>Settings</label>
          <div class="form-group mb-3">
            <object-editor name="settings" [(data)]="model.profile.settings" class="form-control"></object-editor>
          </div>
        </ng-container>
        <ng-container *ngIf="!editCustomFields">
          <label>Title</label>
          <div class="form-group mb-3">
            <input type="text" name="settings-title" [(ngModel)]="model.profile.settings.title" class="form-control" autocomplete="off" />
          </div>
          <label>First Name</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="settings-firstname"
              [(ngModel)]="model.profile.settings.firstname"
              class="form-control"
              autocomplete="off"
            />
          </div>
          <label>Last Name</label>
          <div class="form-group mb-3">
            <input
              type="text"
              name="settings-lastname"
              [(ngModel)]="model.profile.settings.lastname"
              class="form-control"
              autocomplete="off"
            />
          </div>
        </ng-container>
      </div>

      <!-- Labels -->
      <div *ngIf="editCustomFields && model.usage !== 'empowerment'">
        <label>Labels</label>
        <div class="form-group mb-3">
          <object-editor name="labels" [(data)]="model.profile.labels" class="form-control"></object-editor>
        </div>
      </div>

      <!-- Roles -->
      <div>
        <label>Roles</label>
        <div class="form-group mb-3">
          <role-selector
            ngModel
            name="roles"
            [selection]="model.profile.meta.roles"
            [roles]="roles"
            (onSelect)="model.profile.meta.roles = $event"
            class="form-control"
            [class.is-invalid]="!isValidRoles()"
          >
          </role-selector>
        </div>
      </div>

      <!-- Licences (user activated) -->
      <div *ngIf="config.update && model.profile.meta.licences?.length > 0">
        <label>Activated Licences</label>
        <div class="form-group mb-3">
          <div class="form-control">
            <table class="table">
              <thead class="text-primary">
                <tr>
                  <th>Key</th>
                  <th>Roles</th>
                  <th>Expiration</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let licence of model.profile.meta.licences; let index = index">
                  <td>{{ licence.key }}</td>
                  <td>{{ licence.roles?.join(', ') }}</td>
                  <td
                    *ngIf="activate[licence.key]"
                    class="text-secondary"
                    ngbTooltip="The expiration date will be updated on submit depending on the current licence configuration"
                    container="body"
                  >
                    Pending
                  </td>
                  <td *ngIf="!activate[licence.key] && !!licence.duration" [class.text-danger]="!licence.active">
                    {{ duration.formatIso(licence.duration) }}
                  </td>
                  <td *ngIf="!activate[licence.key] && !licence.duration" [class.text-danger]="!licence.active">
                    {{ licence.expiration | date:dateFormat }}
                  </td>
                  <td>
                    <span class="btn-wrapper" ngbTooltip="Reactivate the licence on the profile" placement="left">
                      <button
                        type="button"
                        class="btn btn-sm btn-icon btn-secondary me-1"
                        [class.btn-success]="!!activate[licence.key]"
                        (click)="activate[licence.key] = !activate[licence.key]"
                      >
                        <fa-icon [icon]="['fal','sync']" [fixedWidth]="true"></fa-icon>
                      </button>
                    </span>
                    <span class="btn-wrapper" ngbTooltip="Remove" placement="left">
                      <button type="button" class="btn btn-sm btn-danger btn-icon" (click)="removeLicenceAt(index)">
                        <fa-icon [icon]="['fal','times']" [fixedWidth]="true"></fa-icon>
                      </button>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Licence (user specific) -->
      <div *ngIf="config.template && config.licence === Feature.optional">
        <label>Licence Key</label>
        <input type="checkbox" class="checkbox-inline align-middle" name="licenceToggle" [(ngModel)]="licenceEditing" />
        <div *ngIf="licenceEditing">
          <div class="form-group mb-3">
            <input
              type="text"
              name="licence"
              placeholder="Licence Key"
              [(ngModel)]="model.key"
              class="form-control"
              [class.is-invalid]="!isValidLicence()"
              autocomplete="off"
            />
            <div class="info">
              Register the user with a licence key in addition to a username. The licence key must be unique.<br />
              The user will be displayed in the LICENCE tab instead.
            </div>
          </div>
        </div>
      </div>

      <!-- Expiration -->
      <div>
        <label>Expiration</label>
        <div class="form-group mb-3">
          <div class="datepicker-container">
            <input
              class="form-control datetimepicker"
              [class.is-invalid]="!isValidExpiration()"
              placeholder="yyyy-mm-dd"
              [(ngModel)]="expiration"
              id="expiration"
              name="expiration"
              #dp="ngbDatepicker"
              (click)="dp.toggle()"
              [ngModelOptions]="{updateOn:'blur'}"
              autocomplete="off"
              ngbDatepicker
            />
          </div>
          <div *ngIf="!isValidExpirationOrDuration()" class="warning">Either expiration or duration may be specified exclusively.</div>
        </div>
      </div>

      <!-- Duration -->
      <div *ngIf="config.template">
        <label>Duration</label>
        <div class="form-group mb-3">
          <duration-picker [(value)]="model.profile.meta.duration"></duration-picker>
        </div>
      </div>

      <!-- Password -->
      <div *ngIf="!config.template">
        <div *ngIf="config.update">
          <label>Update Password</label>
          <input class="checkbox-inline" name="passwordToggle" type="checkbox" [(ngModel)]="passwordEditing" />
        </div>
        <div *ngIf="!config.update || passwordEditing">
          <label *ngIf="!config.update" for="password">Password</label>
          <div class="form-group mb-3">
            <input
              type="password"
              name="password"
              [(ngModel)]="password"
              class="form-control"
              [class.is-invalid]="!isValidPassword()"
              autocomplete="off"
              [required]="!config.template && !config.update"
            />
          </div>
          <label for="passwordConfirm">Confirm Password</label>
          <div class="form-group mb-3">
            <input
              type="password"
              name="passwordConfirm"
              [(ngModel)]="passwordConfirm"
              class="form-control"
              [class.is-invalid]="!isValidPasswordConfirm()"
              autocomplete="off"
              [required]="!config.template && !config.update"
            />
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="!f.form.valid || !isValid()">Submit</button>
      </div>
    </div>
  </form>
</div>
